<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Document Verification <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i>
                Verify Document Form</h1>
            <div class="content-wrap">
                <h3 class="form-hd">Fill the form below to verify your document.</h3>
                <form [formGroup]="form">
                    <br>
                    <div formArrayName="StudentDocVerificationRequest"
                        *ngFor="let time of form.controls.StudentDocVerificationRequest?.value; let i = index; trackBy:trackByFn">
                        <div [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="firstName" class="form-label">First Name</label>
                                        <input value={{firstName}} placeholder="firstname" disabled
                                            formControlName="firstname" class="form-control form-input">
                                    </div>

                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="lastName" class="form-label">Last Name</label>
                                        <input value={{lastName}} placeholder="lastname" disabled
                                            formControlName="lastname" class="form-control form-input">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="enNumber" class="form-label">Seat Number</label>
                                        <input placeholder="Enter Seat No." formControlName="enrollno"
                                            class="form-control form-input">
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="col-md-3">
                                <div class="form-group input-group-lg">
                                    <label for="embassy" class="form-label">Embassy</label>
                                    <select formControlName="embassyid" class="form-control form-input" id="embassyid"   
                                    placeholder="Please select Where Do you Need verification For?" 
                                    (change)='getembassylist($event.target.value,i)'>
                                        <option value="" disabled selected>select Where Do you Need verification For?</option>
                                        <option *ngFor="let embassy of EmbassyDropDown" [ngValue]="embassy.id">
                                            {{embassy.embassy}}</option>
                                    </select>
                                </div>
                            </div> -->

                           

                            <div class="row">
                             
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="stream" class="form-label">Stream</label>
                                        <select formControlName="streamid" class="form-control form-input" id="streamid"
                                            placeholder="Select Your Stream"
                                            (change)='getBranAndStream($event.target.value,i)'>
                                            <option value="" disabled selected> Please select Stream </option>
                                            <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                                                {{stream.streamName}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="branch" class="form-label">Branch</label>
                                        <select formControlName="branchId" class="form-control form-input"
                                            id="branchId">
                                            <option value="" disabled selected> Please select Branch </option>
                                            <option *ngFor="let branch of branchDropDown[i]" [ngValue]="branch.id">
                                                {{branch.branchName}}</option>
                                        </select>
                                    </div>
                                </div>

                                

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="semester" class="form-label">Semester</label>
                                        <select formControlName="semId" class="form-control form-input" id="semId">
                                            <option value="" disabled selected> Please select Semester </option>
                                            <option *ngFor="let semester of semesterDropDown[i]"
                                                [ngValue]="semester.id">
                                                {{semester.semester}}</option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="document" class="form-label">Document</label>
                                        <select formControlName="docname" class="form-control form-input" id="docname">
                                            <option value="" disabled selected> Please select Document </option>
                                            <option *ngFor="let document of documentDropDown" [ngValue]="document.id">
                                                {{document.documentName}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="requesttype" class="form-label">Request Type</label>
                                        <select formControlName="requesttype" class="form-control form-input"
                                            id="requesttype">
                                            <option value="" disabled selected> Please select Request Type </option>
                                            <option *ngFor="let request of RequestTypeDropDown" [ngValue]="request.id">
                                                {{request.requestType}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="college" class="form-label">College Name</label>
                                        <select formControlName="collegenameid" class="form-control form-input"
                                            id="collegeNameId">
                                            <option value="" disabled selected> Please select College </option>
                                            <option *ngFor="let college of collegeDropDown" [ngValue]="college.id">
                                                {{college.collegeName}}</option>

                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="passingYear" class="form-label">Year of Passing</label>
                                        <!-- <select formControlName="yearofpassid" class="form-control form-input"
                                            id="yearofpassid">
                                            <option value="" disabled selected> Please select Year Of Passing </option>

                                            <option *ngFor="let year of YearOfPassDropDown" [ngValue]="year.id">
                                                {{year.yearOfPassing}}</option>
                                        </select> -->

                                        <mat-form-field>
                                            <input matInput [matDatepicker]="dp"   autocomplete="off"
                                                placeholder="Select Month and Year" formControlName="yearAndMonthSelect"  [matDatepickerFilter]=dateFilter >
                                            <mat-datepicker-toggle matSuffix [for]="dp" ></mat-datepicker-toggle>
                                            <mat-datepicker #dp startView="multi-year" 
                                                (yearSelected)="chosenYearHandler($event)"
                                                (monthSelected)="chosenMonthHandler($event, dp,i)"
                                                panelClass="example-month-picker">
                                            </mat-datepicker>
                                            <!-- <input placeholder="Enter yearAndMonth" formControlName="yearAndMonth"
                                                class="form-control form-input"> -->
                                        </mat-form-field>

                                        
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="altEmail" class="form-label">Alternate EmailID <span style="color:#21B4F3;font-size:100% ;"> Max 5 comma separated email ids allowed.</span></label>
                                        <input placeholder="Enter EmailId" formControlName="altEmail"
                                            class="form-control form-input"  (change)="inputChanged($event,i)"
                                            [ngClass]="{ 'is-invalid': submitted && fa.controls[i].controls.altEmail.invalid}">
                                            <div *ngIf="altEmailLengthCheck">
                                                <div style="color:red;">Only upto 5 emails permitted.</div>
                                            </div>
                                            <div *ngIf="altEmailValidation">
                                                <div style="color:red;">Please enter correct email ids.</div>
                                            </div>
                                        <div *ngIf="submitted && fa.controls[i].controls.altEmail.invalid"
                                            class="invalid-feedback">
                                             <div *ngIf="fa.controls[i].controls.altEmail.errors.pattern">Email must be a
                                                valid email address
                                            </div> 
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="uploadDocPath" class="form-label">Upload Document<span style="color:#f32f21;font-size:15px ;"> All semester marksheets should be uploaded in one PDF (upto 5 MB).</span></label>
                                        <input formControlName="uploaddocpath" type="file"
                                            class="form-control form-input border-none"
                                            accept=".png,.jpg,.jpeg,.tiff,.pdf" id="uploadDocPath"
                                            (change)="catchEvent($event.target.files, i); selectedRow=i">
                                            <div [hidden]="selectedRow !== i ">
                                                <div *ngIf="fileSizeErr">
                                                    <p style="color:#dc3545;font-size:100% ;">File size should be below 5MB.</p>
                                                </div>
                                                <div *ngIf="errorMessage">
                                                    <p style="color:#dc3545;font-size:100%;">{{ errorMessage }}</p>
                                                  </div>
                                            </div>
                                        <div class="invalid-feedback">
                                            <div>Upload Document is required</div>
                                        </div>
                                        <!-- <div *ngIf="fileSizeErr">
                                            <p style="color:#dc3545;font-size:100% ;">File size should be below 1MB.</p>
                                        </div> -->
                                    </div>
                                </div>
                                <input placeholder="filepath" formControlName="filepath" hidden>                    


                            </div>

                            <div class="row">
                        <div class="col-md-3" >
                                    <div class="form-group input-group-lg">
                                        <label for="college" class="form-label">Verification Purpose</label>
                                        <select formControlName="embassyid" class="form-control form-input"
                                        
                                            id="embassyid" (change)="getembassylist($event.target.value)">
                                            <option value="" disabled selected>Please select verification Purpose</option>
                                            <option *ngFor="let embassy of EmbassyDropDown" [ngValue]="embassy.id">
                                                {{ embassy.embassyName }}</option>
      
                                        </select>
                                    </div>
                        </div>

                        <div class="col-md-3">

                            
                            <div class="form-group input-group-lg">
                                <label for="embassyname" class="form-label">Embassy Name</label>
                                <input placeholder="firstnames"  [readonly]="embassyidDisabled"
                                    formControlName="embassyname" class="form-control form-input">
                            </div>
                          </div>
                          
                          <div class="col-md-3">
                            <div class="form-group input-group-lg">
                              <label for="embassyaddress" class="form-label">Embassy Address</label>
                              <input
                                placeholder="Embassy Address"
                                formControlName="embassyaddress"
                                [readonly]="embassyidDisabled"
                                class="form-control form-input"/>

                            </div>
                          </div>
                          
                        
                        <!-- <div class="col-md-3" >
                           
                                <div class="form-group input-group-lg">
                                    <label for="embassyname" class="form-label">Embassy Name</label>
                                    <input placeholder="embassy name" formControlName="embassyname" [readonly]="embassyidDisabled" class="form-control form-input" >

                                </div>
                                
                       
                        </div>

                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="embassyAddress" class="form-label">Embassy Address</label>
                                <input placeholder="embassy address" formControlName="embassyaddress" 
                                [readonly]=embassyidDisabled  class="form-control form-input">
                                
                            </div>
                        </div> -->

                    </div>



                            </div>


  



                        <button class="delete-btn" (click)="removeGroup(i)"><i class="fa fa-minus-circle fa-icon"
                                aria-hidden="true"></i>Remove </button>
                    </div>

                    <br>
                    <div *ngIf="ifZeroAmount">
                        <div class="col-md-12">
                            <p class="system-status"> <span class="color-red">Request can not be created for
                                    {{noYrPriceMast}} year.</span></p>
                        </div>
                    </div>
                    <button class="add-more-btn" hidden (click)="addGroup()"
                        [disabled]="form.get('StudentDocVerificationRequest').invalid"> <i
                            class="fa fa-plus-circle fa-icon" aria-hidden="true"></i>Add More</button>
                    <button class="proceed-btn bg-theme" hidden #closebuttonRemark></button>
                    <button class="proceed-btn bg-theme" (click)="onSubmit()" data-toggle="modal"
                        data-target="#disputeModal">
                        Proceed to Payment</button>
                    <!-- <button class="proceed-btn" (click)="pay()"  data-toggle="modal" data-target="#confirmModal">Pay</button> -->
                    <!-- <button id="rzp-button1">Pay</button> -->
                </form>
                <div *ngIf="showErr == true">
                    <p style="color:#dc3545;font-size:100% ;">Please enter values in all fields.</p>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <p class="note-txt">Note: If request type is Express then your record will be processed within 3
                        days and a additional fee of Rs. 500 will be charged.</p>
                </div>
            </div> -->
        </div>
    </div>
</div>

<div class="modal fade" *ngIf="IsmodelShow" id="disputeModal" tabindex="-1" role="dialog"
    aria-labelledby="disputeModalLabel" aria-hidden="true">
    <div class="modal-header bg-theme">
        <h5 class="modal-title" id="disputeModalLabel">The Verification Document has been Saved.</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>

</ng-template>

<div class="modal fade" *ngIf="IsmodelShow" id="confirmModal" tabindex="-1" role="dialog"
    aria-labelledby="viewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header success-modal-header">
                <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                    <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                            alt="img"></span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <h3 class="success-text">Success</h3>
                        <p class="reset-hd2">{{strMessage}}</p>
                    </div>
                </div>
                <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal"
                    (click)="refresh()">Done</button>
            </div>

        </div>
    </div>
</div>

<ng-template #showModalBoxAlert class="modal fade " id="alertModal" tabindex="-1" role="dialog" let-c="close"
  let-d="dismiss" aria-labelledby="alertModalLabel" aria-hidden="false">
  <div class="modal-content">
    <div class="modal-header  bg-theme">
        <h3 class="modal-title" id="alertModalLabel">Payment Alert</h3>
      
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <!-- <h3 class="success-text">Alert</h3> -->
          <p class="reset-hd2">Once payment process starts , please do not close or refresh any
            window till payment process is complete.</p>
        </div>
      </div>
      <button class="approve-modal-btn2 bg-theme mr-auto" (click)="closeAlert()" data-dismiss="modal">Ok</button>
    </div>
  </div>
</ng-template>